import { Consents, CookieTypes } from "./AnalyticsEvents";
import { useMemo, useSyncExternalStore } from "react";

declare const window: typeof globalThis["window"] & {
  OnetrustActiveGroups?: string;
};

const defaultConsents: Consents = {
  necessary: false,
  performance: false,
  functional: false,
  targeting: false,
  socialMedia: false,
};

/**
 * Returns null before OneTrust has loaded.
 */
function getActiveOneTrustGroups() {
  return window.OnetrustActiveGroups ?? null;
}

function parseConsents(groups: string) {
  const consents: Consents = { ...defaultConsents };
  for (const key of Object.keys(defaultConsents) as Array<
    keyof typeof defaultConsents
  >) {
    consents[key] = groups.includes(CookieTypes[key]);
  }

  return consents;
}

const CONSENT_CHANGED_EVENT = "OptanonConsentChanged";

function addOneTrustConsentChangedListener(listener: () => void) {
  window.addEventListener(CONSENT_CHANGED_EVENT, listener);
}

function removeOneTrustConsentChangedListener(listener: () => void) {
  window.removeEventListener(CONSENT_CHANGED_EVENT, listener);
}

function subscribe(listener: () => void) {
  addOneTrustConsentChangedListener(listener);

  return () => {
    removeOneTrustConsentChangedListener(listener);
  };
}

function getServerSnapshot() {
  return null;
}

/**
 * Returns null before OneTrust is loaded
 */
export const useCookieConsent = () => {
  const consentGroup = useSyncExternalStore(
    subscribe,
    getActiveOneTrustGroups,
    getServerSnapshot
  );

  return useMemo(
    () => (consentGroup ? parseConsents(consentGroup) : null),
    [consentGroup]
  );
};
